// extracted by mini-css-extract-plugin
module.exports = {"load-shedding-E":"E_load-shedding-E__gzpPf"};